import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColumnWideAdd"><Path d="M2 4V20H13V6H20V11H22V4H2Z" fill="currentColor"/><Path d="M20 13H18V16H15V18H18V21H20V18H23V16H20V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideAdd;
